import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import WhyOnlineSection from '@/pages/home/components/WhyOnlineSection';
import GallerySection from '@/pages/home/components/GallerySection';
import HowToSection from '@/pages/home/components/HowToSection';
import ProcessSection from '@/pages/home/components/ProcessSection';
import FaqSection from '@/pages/home/components/FaqSection';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <WhyOnlineSection />
      <GallerySection />
      <HowToSection />
      <ProcessSection />
      <FaqSection />
      <Footer />

      {/* 블로그 플로팅 버튼 */}
      <a
        href="https://blog.naver.com/hanskid"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 cursor-pointer flex flex-col items-center gap-1 group"
      >
        <div className="w-14 h-14 flex items-center justify-center bg-green-500 rounded-full group-hover:bg-green-600 transition-colors">
          <i className="ri-article-line text-2xl text-white"></i>
        </div>
        <span className="text-xs font-bold text-white bg-green-500 group-hover:bg-green-600 transition-colors px-2 py-0.5 rounded-full whitespace-nowrap">
          블로그 바로가기
        </span>
      </a>
    </div>
  );
}
